import type { IPathBaseParam, IPathByIdParam } from "./path";

import { me } from "@api/users/me/api";
import type {
  IUserDto,
  IUserGetAllParams,
  IUserGetParams,
  IUsersResponse,
} from "@api/users/types";
import { createDeleteApi } from "@api/util/createDeleteApi";
import { createGetAllApi } from "@api/util/createGetAllApi";
import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { bulk } from "@api/users/bulk/api";
import { register } from "@api/users/register/api";
import { setPassword } from "@api/users/setPassword/api";
import { stats } from "@api/users/stats/api";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IUsersResponse>>,
  IPathBaseParam,
  IPaginationParams & IUserGetAllParams
>("users");
const postApis = createPostApi<
  IApiResponse<IUsersResponse>,
  IPathBaseParam,
  IUserDto
>("users");
const getApis = createGetApi<
  IApiResponse<IUsersResponse>,
  IPathByIdParam,
  IUserGetParams
>("users");
const patchApis = createPatchApi<
  IApiResponse<IUsersResponse>,
  IPathByIdParam,
  IUserDto
>("users");
const deleteApis = createDeleteApi<
  IApiResponse<IUsersResponse>,
  IPathByIdParam
>("users");

export const users = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
  me,
  bulk,
  register,
  setPassword,
  stats,
};
